import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { ContentType, PagePart } from 'app/modules/step-engine/utils/step-engine-constants';
import { skeletonLoader } from 'app/modules/step-engine/utils/step-engine-methods';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './footer.scss';
import moment from 'moment';



interface IDocument {
    label: string,
    url: string
}

interface IFooter {
    didomi: any,
    appGlobalType: any,
    footerLinks: any,
}

const Footer = (props: IFooter) => {
    const dispatch = useDispatch();
    const { didomi, footerLinks } = props
    const divRef = useRef(null);
    const { verticalDisplay } = useSelector((state: IRootState) => state.appManagement?.frontConfig);
    const { currentSteps, currentStepGroup } = useSelector((state: IRootState) => state.stepEngine.stepData);
    const stepList = useSelector((state: IRootState) => state.stepEngine.stepList);
    const { isMobile, cmsContent } = useSelector((state: IRootState) => state.cms);
    const { cookieManagement } = cmsContent[PagePart.APP_GLOBAL_TYPE]?.prismic || {}
    const { bottomIcon } = cmsContent[PagePart.GENERIC_SIDE_NAV_PDV]?.prismic || {}
    const isInVerticalDisplay = verticalDisplay && !isMobile;

    useEffect(() => {

        if (isInVerticalDisplay) {
            if (stepList.filter((x) => x.stepGroup === currentStepGroup).length <= 1)
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }
    }, [currentSteps, currentStepGroup]);

    const gestionCookies = didomiObject => {
        if (didomiObject) {
            didomiObject.preferences.show();
        }
    };

    const openDocument = (item: any) => {
        dispatch(gtmEvent(item.label, 'Consultation', '0'));
        window.open(item.url, '_blank', 'noopener,noreferrer');
    }

    const getLink = (contentType: ContentType) => {
        const item = footerLinks[contentType];
        return (
            <>
                <span className="p-2">•</span><a onClick={() => openDocument(item)}>{(item?.label)}</a>
            </>
        )
    }

    return (

        <div className="footer-container" id="footer-container">
            {
                footerLinks ?
                    <>
                        <div className='footer-logo'>
                            <img className={'footer-img'} alt="Logo utilisateur" src={bottomIcon} />
                        </div>
                        <div className="footerConditions text-center">
                            {getLink(ContentType.LEGAL_NOTICE)}
                            {getLink(ContentType.PRIVACY_POLICY)}
                            {getLink(ContentType.TERMS_OF_SERVICE)}
                            
                            <span className="p-2">•</span><a onClick={() => gestionCookies(didomi)} style={didomi ?? { cursor: 'initial', color: 'gray' }}>{cookieManagement}</a>
                        </div>
                        <div className="spb-footer-version" ref={divRef}>Copyright © {moment().format('YYYY')} version : {process.env.REACT_APP_VERSION.replace('-SNAPSHOT', '')}</div>
                    </>
                    :
                    skeletonLoader('footerSkel')
            }
        </div>


    )
};

export default Footer;